import OliverText from "@builder/components/general/OliverText";
import UnitInput from "../UnitInput";
import "./style.scss";
import { useTranslation } from "react-i18next";

export type AllSidesInputInit = {
    top: { value: string; unit: string };
    right: { value: string; unit: string };
    bottom: { value: string; unit: string };
    left: { value: string; unit: string };
};

interface AllSidesInputProps {
    title?: string;
    init: AllSidesInputInit;
    callback: (inputs: AllSidesInputInit) => void;
}

const AllSidesInput: React.FC<AllSidesInputProps> = ({ title, init, callback }: AllSidesInputProps) => {
    const { t } = useTranslation();

    const topCallback = (value: string, unit: string) => {
        callback({
            top: { value, unit },
            right: init.right.value ? init.right : { value: "0", unit: init.right.unit },
            bottom: init.bottom.value ? init.bottom : { value: "0", unit: init.bottom.unit },
            left: init.left.value ? init.left : { value: "0", unit: init.left.unit }
        });
    };
    const rightCallback = (value: string, unit: string) => {
        callback({
            top: init.top.value ? init.top : { value: "0", unit: init.top.unit },
            right: { value, unit },
            bottom: init.bottom.value ? init.bottom : { value: "0", unit: init.bottom.unit },
            left: init.left.value ? init.left : { value: "0", unit: init.left.unit }
        });
    };
    const bottomCallback = (value: string, unit: string) => {
        callback({
            top: init.top.value ? init.top : { value: "0", unit: init.top.unit },
            right: init.right.value ? init.right : { value: "0", unit: init.right.unit },
            bottom: { value, unit },
            left: init.left.value ? init.left : { value: "0", unit: init.left.unit }
        });
    };
    const leftCallback = (value: string, unit: string) => {
        callback({
            top: init.top.value ? init.top : { value: "0", unit: init.top.unit },
            right: init.right.value ? init.right : { value: "0", unit: init.right.unit },
            bottom: init.bottom.value ? init.bottom : { value: "0", unit: init.bottom.unit },
            left: { value, unit }
        });
    };

    const handleApplyAll = () => {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLInputElement && activeElement?.classList.contains("value-input")) {
            const unitElement = activeElement.nextElementSibling?.querySelector("input");
            if (unitElement) {
                const newValue = { value: activeElement.value, unit: unitElement.value };
                callback({
                    top: newValue,
                    right: newValue,
                    bottom: newValue,
                    left: newValue
                });
            }
        }
    };

    return (
        <div className="all-sides-input-wrapper">
            {title && <OliverText text={t("generalComponents.allSidesInput." + title)} size="xs" />}
            <div className="all-side-inputs">
                <UnitInput value={init.top.value} unit={init.top.unit} callback={topCallback} />
                <div className="input-row">
                    <UnitInput value={init.left.value} unit={init.left.unit} callback={leftCallback} />
                    <UnitInput value={init.right.value} unit={init.right.unit} callback={rightCallback} />
                </div>
                <UnitInput value={init.bottom.value} unit={init.bottom.unit} callback={bottomCallback} />
            </div>
            <button onMouseDown={handleApplyAll}>{t("generalComponents.allSidesInput.Apply All")}</button>
        </div>
    );
};

export default AllSidesInput;
